import React from 'react';
import "../../assets/css/button.css";

const Button = ({ buttonStyle, disabled = false, onChangeValue, title }) => {
    return (
        <button className={buttonStyle} disabled={disabled} onClick={onChangeValue}>
            {title}
        </button>
    );
};

export default Button;
